import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared/guards/auth.guards';
import { PendingChangesGuard } from '../../shared/guards/pending-changes.guard';
import { Groups } from '../security/model/groups.model';
import { AssetAddComponent } from './components/add/asset-add.component';
import { BulkAddAssetsStatusComponent } from './components/bulk-add-asset-status/bulk-add-asset-status.component';
import { AssetEditComponent } from './components/edit/asset-edit.component';
import { AssetListComponent } from './components/list/asset-list.component';
import { AssetViewComponent } from './components/view/asset-view.component';

export class AssetRoutingStates {
  public static readonly LIST = {
    url: 'asset'
  };
  public static readonly VIEW = {
    url: `${AssetRoutingStates.LIST.url}/:id/view`
  };
  public static readonly ADD = {
    url: `${AssetRoutingStates.LIST.url}/add`
  };
  public static readonly EDIT = {
    url: `${AssetRoutingStates.LIST.url}/:id/edit`
  };
  public static readonly BULK_UPLOAD_ASSETSTATUS = {
    url: `${AssetRoutingStates.LIST.url}/bulkaddassetstatus`
  };
}

export const AssetRoutes: Routes = [
  {
    path: AssetRoutingStates.LIST.url,
    data: {
      page: {
        title: 'Asset List'
      },
      requiresRole: [
        Groups.ASSET_ADMINISTRATOR,
        Groups.ASSET_MANAGER,
        Groups.ASSET_VIEWER
      ]
    },
    component: AssetListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: AssetRoutingStates.VIEW.url,
    data: {
      page: {
        title: 'Asset View'
      },
      requiresRole: [
        Groups.ASSET_ADMINISTRATOR,
        Groups.ASSET_MANAGER,
        Groups.ASSET_VIEWER
      ]
    },
    component: AssetViewComponent,
    canActivate: [AuthGuard]
  },
  {
    path: AssetRoutingStates.ADD.url,
    data: {
      page: {
        title: 'Asset Add'
      },
      requiresRole: [Groups.ASSET_ADMINISTRATOR, Groups.ASSET_MANAGER]
    },
    component: AssetAddComponent,
    canActivate: [AuthGuard]
  },
  {
    path: AssetRoutingStates.EDIT.url,
    data: {
      page: {
        title: 'Asset Edit'
      },
      requiresRole: [Groups.ASSET_ADMINISTRATOR, Groups.ASSET_MANAGER]
    },
    component: AssetEditComponent,
    canActivate: [AuthGuard]
  },
  {
    path: AssetRoutingStates.BULK_UPLOAD_ASSETSTATUS.url,
    data: {
      page: {
        title: 'Bulk Add Assets Status'
      },
      requiresRole: [Groups.ASSET_ADMINISTRATOR]
    },
    component: BulkAddAssetsStatusComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(AssetRoutes)]
})
export class AssetRoutingModule {}
